/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";

import "./Home.scss";
import { ShowSnackbar } from "../Common";

const Home = (props) => {
	const [notification, setNotification] = React.useState({ message: "", severity: "success" });
	const handleSnackBarClose = () => {
		setNotification({ message: "", severity: "success" });
	};

	React.useEffect(() => {
		if (props.location?.state?.redirectReason === "Unauthorized") {
			setNotification({ message: "Unauthorized Page Access Denied.", severity: "error" });
		}
	}, [setNotification, props.location?.state?.redirectReason]);

	return (
		<>
			<ShowSnackbar message={notification.message} severity={notification.severity} onClose={handleSnackBarClose} />
			<em className="welcomeMessage">Welcome to PACE. Please select an option on the left.</em>
		</>
	);
};

export default Home;
